
import CouponsView from "./views";

function Coupons() {
    return (
        <CouponsView />
    )
}

export default Coupons;